import * as React from 'react'

import { Icon, Text, Tooltip, useToggle } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

const NineBoxTooltip = () => {
  const [open, toggle] = useToggle(false)

  return (
    <Tooltip.ItemList
      attachment="top center"
      open={open}
      toggle={toggle}
      title={i18n.t('custom_reports.tooltip_info.9_box.title')}
    >
      <Icon.Medium icon="info-circle-line" color="grey800" />
      <Text.Normal>{i18n.t('custom_reports.tooltip_info.9_box.description')}</Text.Normal>
    </Tooltip.ItemList>
  )
}

export default NineBoxTooltip
